module.exports = __webpack_public_path__ + "assets/PSS_logo_white.1511ed5c.png";